// utils/authUtils.js - Authentication utility functions
import { AUTH_CONFIG } from '../config/auth';

export const authUtils = {
    // Check if user is authenticated
    isAuthenticated: () => {
        try {
            const authData = localStorage.getItem(AUTH_CONFIG.SESSION_KEY);
            if (authData) {
                const { authenticated, timestamp } = JSON.parse(authData);
                const now = Date.now();

                // Check if session is still valid (24 hours)
                if (authenticated && (now - timestamp) < AUTH_CONFIG.SESSION_DURATION) {
                    return true;
                } else {
                    // Session expired, clear storage
                    authUtils.logout();
                    return false;
                }
            }
            return false;
        } catch (error) {
            console.error('Auth check error:', error);
            authUtils.logout();
            return false;
        }
    },

    // Store authentication with timestamp
    login: () => {
        const authData = {
            authenticated: true,
            timestamp: Date.now()
        };
        localStorage.setItem(AUTH_CONFIG.SESSION_KEY, JSON.stringify(authData));
    },

    // Clear authentication
    logout: () => {
        localStorage.removeItem(AUTH_CONFIG.SESSION_KEY);
    },

    // Get session expiry time
    getSessionExpiry: () => {
        try {
            const authData = localStorage.getItem(AUTH_CONFIG.SESSION_KEY);
            if (authData) {
                const { timestamp } = JSON.parse(authData);
                return new Date(timestamp + AUTH_CONFIG.SESSION_DURATION);
            }
            return null;
        } catch (error) {
            return null;
        }
    },

    // Get remaining session time in milliseconds
    getRemainingSessionTime: () => {
        try {
            const authData = localStorage.getItem(AUTH_CONFIG.SESSION_KEY);
            if (authData) {
                const { timestamp } = JSON.parse(authData);
                const now = Date.now();
                const remaining = (timestamp + AUTH_CONFIG.SESSION_DURATION) - now;
                return Math.max(0, remaining);
            }
            return 0;
        } catch (error) {
            return 0;
        }
    }
};